// Copyright (c) 2019 by Michael Marucheck
//
// Use of this source code is governed by an MIT-style license that
// can be found in the LICENSE file distributed with this file.

import React from "react";
import { Link } from "react-router-dom";
import "./common.css";

interface BreadcrumbsProps {
  crumbs: Breadcrumb[];
}

export interface Breadcrumb {
  name: string;
  url: string;
}

export const Breadcrumbs: React.FC<BreadcrumbsProps> = ({ crumbs }) => {
  return (
    <div className="breadcrumbs">
      {crumbs.map(({ name, url }) => (
        <span key={name}>
          {" > "}
          <Link to={url}>{name}</Link>
        </span>
      ))}
      <span key="here"> > (this page)</span>
    </div>
  );
};

// function join(
//   acc: React.ReactNode[],
//   elem: React.ReactNode
// ): React.ReactNode[] {
//   return acc.length === 0 ? [elem] : [...acc, " / ", elem];
// }

/*
      {crumbs
        .map(({ name, url }) => (
          <Link key={name} to={url}>
            {name}
          </Link>
        ))
        .reduce(join, [])}
*/
